import { render, staticRenderFns } from "./settlementProject.vue?vue&type=template&id=b99ee7aa&scoped=true&"
import script from "./settlementProject.vue?vue&type=script&lang=js&"
export * from "./settlementProject.vue?vue&type=script&lang=js&"
import style0 from "./settlementProject.vue?vue&type=style&index=0&id=b99ee7aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99ee7aa",
  null
  
)

export default component.exports